{
  "personalInformation": {
    "inputs": {
      "property": {
        "label": "Bostadstyp",
        "placeholder": "Välj bostadstyp",
        "requiredError": "Du måste ange bostadstyp innan du går vidare.",
        "options": {
          "villa": "Villa/radhus",
          "apartment": "Bostadsrätt",
          "rental": "Hyresrätt",
          "recreational": "Fritidshus"
        }
      },
      "municipality": {
        "label": "Kommun",
        "placeholder": "Visa förslag kommun"
      },
      "estimatedExpensesPayment": {
        "label": "Uppskattad månadsavgift/driftkostnad per månad",
        "requiredError": "Du måste ange uppskattad månadsavgift eller driftskostnad innan du går vidare.",
        "tooltip": {
          "payment": {
            "title": "Om du letar efter en lägenhet, Månadsavgift",
            "description": "Lägg till den månatliga avgiften till föreningen här. Om annonsen har information om både avgift och återkommande utgifter, är det avgiften du ska ange här."
          },
          "expenses": {
            "title": "Om du letar efter en fastighet, Driftskostnad",
            "description": "Beräknade månatliga utgifter kan vara t.ex. försäkring, sophämtning, uppvärmning, el och vatten."
          }
        }
      },
      "downPayment": {
        "label": "Kontantinsats",
        "requiredError": "Du måste ange kontantinsats innan du går vidare.",
        "tooltip": "Kontantinsatsen måste uppgå till minst {{downpaymentAmount}}% av uppskattad köpeskilling."
      },
      "monthlyPayment": {
        "label": "Månadsavgift",
        "requiredError": "Du måste ange månadsavgift innan du går vidare."
      },
      "monthlyExpenses": {
        "requiredError": "Du måste ange månadsavgift innan du går vidare."
      },
      "remainingDebt": {
        "label": "Nuvarande skuld",
        "requiredError": "Du måste ange nuvarande skuld innan du går vidare. Har du igen skuld ange {{debtAmount}} kr."
      },
      "creditLimit": {
        "label": "Beviljad kredit",
        "requiredError": "Du måste ange maximal kreditgräns innan du går vidare."
      },
      "monthlyStudentPayment": {
        "label": "Utgift per månad",
        "requiredError": "Du måste ange utgift per månad innan du går vidare."
      },
      "children": {
        "label": "Antal barn som bor hemma",
        "placeholder": "Välj antal barn",
        "requiredError": "Du måste ange antal barn innan du går vidare."
      },
      "cars": {
        "label": "Antal bilar (ägda och leasade)",
        "placeholder": "Välj antal bilar",
        "requiredError": "Du måste ange antal bilar innan du går vidare."
      },
      "loanCredit": {
        "label": "Välj typ av lån/kredit",
        "placeholder": "Välj lån/kredit",
        "requiredError": "Du måste ange lånetyp innan du går vidare.",
        "options": {
          "creditCard": "Kreditkort",
          "guarantee": "Bil/båt/MC lån",
          "studentLoan": "Studielån",
          "otherLoan": "Andra lån"
        }
      }
    }
  },
  "addProperty": "Lägg till bostad du ska behålla",
  "addOtherProperty": "Lägg till annan bostad du ska behålla",
  "removeProperty": "Ta bort bostad",
  "addLoanCredit": "Lägg till lån/kredit",
  "addOtherLoanCredit": "Lägg till ytterligare lån/kredit",
  "removeLoanCredit": "Ta bort lån/kredit",
  "calculationResult": {
    "heading": "Du kan preliminärt låna",
    "description": "Följande siffror är en indikation på hur mycket du kan låna baserat på de uppgifter du har fyllt i. För att ansöka om ett lånelöfte kan du klicka på knappen nedan.",
    "loanAmount": "Lånebelopp",
    "downPayment": "Kontantinsats",
    "propertyPrice": "Bostadens pris",
    "ltv": "Belåningsgrad",
    "inputs": {
      "adjustLoanAmount": {
        "label": "Justera lånebeloppet",
        "tooltip": "Om du justerar lånebeloppet kan du se hur det påverkar bostadens pris, belåningsgraden och månadskostnaden."
      }
    },
    "error": {
      "loanAmount": "Preliminärt maxbelopp att låna är {{amount}}",
      "noIndication": {
        "heading": "Vi kan inte ge dig en indikation",
        "body": "Med den information du har fyllt i kan vi inte ge dig en indikation på hur mycket du kan låna. Det kan vara så att din inkomst och kontantinsats är för låg, så vänligen kontrollera att dina uppgifter är korrekt angivna."
      }
    }
  },
  "moreInformation": {
    "items": {
      "calculation": {
        "title": "Läs mer om hur vi har räknat",
        "paragraph1": "Din livssituation, återbetalningsförmåga och totala ekonomi avgör hur mycket du kan låna till att köpa en bostad. Riktlinjen är att du ska klara en ränta på 6 %. En förutsättning för att ta ett bostadslån är att du har en kontantinsats; minst 10 % av bostadens värde för villa, bostadsrätt och fritidshus.",
        "paragraph2": "Även kommunalskatt används i beräkningen. I vissa fall använder vi kommunalskatten från året innan, om det inte hunnit uppdateras i våra system än.",
        "paragraph3": "Vi har räknat på en amorteringstakt enligt rådande amorteringskrav. Läs mer nedan hur de fungerar och vilka amorteringskrav som du omfattas av."
      },
      "nextSteps": {
        "title": "Vad är nästa steg?",
        "paragraph1": "Här kan du läsa mer om hur du kan förbereda dig inför ditt bostadsköp och processen steg-för-steg.",
        "link": "Lär vår steg-för-steg guide"
      }
    }
  },
  "disclaimer": {
    "heading": "Villkor",
    "paragraph1": "Vi erbjuder bolån till dig som är kund i Danske Bank.",
    "paragraph2": "Här hittar du aktuella räntor på bolån med rörlig eller bunden ränta:",
    "paragraph3": "Vi erbjuder en färdigförhandlad ränta baserad på tre faktorer, hur hög din belåningsgrad är (lånet i förhållande till din bostads värde), storlek på lånet och om du är medlem i ett fackförbund anslutet till TCO, Saco eller annat företag/organisation med särskilt förhandlade villkor. Värdet på din bostad fastställs av banken. Valutakursförändringar kan komma att påverka kostnaderna för ditt bolån.",
    "paragraph4": "Lån beviljas efter sedvanlig kreditprövning. Befintliga kunder kan se aktuella räntesatser för löptiderna 30 dagar, 4, 6, 7, 8 och 9 år i Hembanken. Löptiderna finns inte längre till nyförsäljning.",
    "paragraph5": "Genomsnittlig ränta beräknas för alla nya bolån och villkorsändringar under föregående månad och baseras på den aktuella annonserade räntan efter eventuell ränterabatt.",
    "paragraph6": "Allmänna villkor - Skuldebrev K (Danske Bolån) för Konsument",
    "paragraph7": "Du som är amerikansk medborgare eller på annan grund skattskyldig i USA kan inte ansöka om denna tjänst/produkt via bankens hemsida. Du är välkommen att kontakta Kundservice på 0752-48 45 42 eller 0752-48 48 48 (Private Banking).",
    "paragraph8": "En förutsättning för krediten är att den är förenad med säkerhet i bostaden.",
    "paragraph9": "Kreditgivare: Danske Bank Sverige, 516401-9811, Norrmalmstorg 1, Box 7523, 103 92 Stockholm",
    "link": "Aktuella räntor (inkl. historik)"
  }
}
